import { render } from "./Paymenttypes.vue?vue&type=template&id=2923225e"
import script from "./Paymenttypes.vue?vue&type=script&lang=js"
export * from "./Paymenttypes.vue?vue&type=script&lang=js"

import "./Paymenttypes.vue?vue&type=style&index=0&id=2923225e&lang=css"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__